module.exports = __webpack_public_path__ + "static/june-5-bf2d2052996ad1ab9b8f7a848f81835a.png";